<template>
  <div class="layout-box">
    <LayoutHeader headtitle="云展会"></LayoutHeader>
    <div class="secondary-content">
      <GoBack></GoBack>
      <div class="experts-list">
        <div class="experts-title">
          <h2>在线会议</h2>
        </div>
        <ul class="huizhan clear">
          <a href="https://app9sksmalo3870.h5.xiaoeknow.com/v2/course/alive/l_60933e82e4b0d4eb03972ea1?app_id=app9sksmAlo3870&alive_mode=0&pro_id=&type=2" target="_blank">
            <li>
              <img src="../../assets/img/yhz-zxhy1.jpg" height="320" width="576"/>
              <p>第十五届中国杭州·纤维素纤维（粘胶）产业链论坛</p>
              <p class="huizhan-p"><font>2021年5月25日--27日 中国·杭州</font><span>在线参会</span></p>
            </li>
          </a>
          <a href="https://app9sksmalo3870.h5.xiaoeknow.com/v2/course/alive/l_60933f1be4b09890f0e934f0?app_id=app9sksmAlo3870&alive_mode=0&pro_id=&type=2" target="_blank">
            <li>
              <img src="../../assets/img/yhz-zxhy2.jpg" height="320" width="576"/>
              <p>第一届莱赛尔纤维产业论坛</p>
              <p class="huizhan-p"><font>2021年5月26日 中国·杭州</font><span>在线参会</span></p>
            </li>
          </a>
        </ul>

        <div class="experts-title">
          <h2>会议回顾</h2>
        </div>
        <ul class="huizhan-hg clear">
          <li>
            <a href="https://forum.ccf.com.cn/fiber/meeting_detail.php?id=2" target="_blank"><font title="杭州·化纤论坛">₪</font> 供需赛跑——经济、货币与政策展望 【2021年】</a>
            <span>2021-04-10</span>
          </li>
          <li>
            <a href="https://forum.ccf.com.cn/fiber/meeting_detail.php?id=16" target="_blank"><font title="杭州·化纤论坛">₪</font> 海外嘉宾现场连线
              ——土耳其eskapet的Levent 新加坡Danone的Nicky和Caiyun</a>
            <span>2021-04-10</span>
          </li>
          <li>
            <a href="https://forum.ccf.com.cn/fiber/meeting_detail.php?id=6" target="_blank"><font title="杭州·化纤论坛">₪</font> 从全球不同原料裂解工艺看乙烯-环氧乙烷-乙二醇产业链发
              ——中化国际 产业资源事业部 战略发展部总经理/化工原料部 总经理 赵军</a>
            <span>2021-04-08</span>
          </li>
          <li>
            <a href="https://forum.ccf.com.cn/fiber/meeting_detail.php?id=5" target="_blank"><font title="杭州·化纤论坛">₪</font> PTA期货在产业中的应用
              ——郑州商品交易所特邀嘉宾 英力士中国区商务总监 纪敬飞</a>
            <span>2021-04-08</span>
          </li>
          <li>
            <a href="https://forum.ccf.com.cn/fiber/meeting_detail.php?id=4" target="_blank"><font title="杭州·化纤论坛">₪</font> 新一轮产能投放周期下的聚酯原料发展趋势
              ——中国石化化工销售有限公司合原合纤部高级主管 黄巍</a>
            <span>2021-04-08</span>
          </li>
          <li>
            <a href="https://forum.ccf.com.cn/fiber/meeting_detail.php?id=3" target="_blank"><font title="杭州·化纤论坛">₪</font> 中国炼化行业“十四五”发展趋势分析 【2021年】</a>
            <span>2021-04-08</span>
          </li>
          <li>
            <a href="https://forum.ccf.com.cn/fiber/meeting_detail.php?id=12" target="_blank"><font title="尼龙产业链论坛">ↇ</font> 疫情后的消费结果变化 【2020年】</a>
            <span>2020-09-10</span>
          </li>
          <li>
            <a href="https://forum.ccf.com.cn/fiber/meeting_detail.php?id=11" target="_blank"><font title="尼龙产业链论坛">ↇ</font> 纯苯产业格局和发展 【2020年】</a>
            <span>2020-09-10</span>
          </li>
          <li>
            <a href="https://forum.ccf.com.cn/fiber/meeting_detail.php?id=10" target="_blank"><font title="尼龙产业链论坛">ↇ</font> 大变局 后疫情期全球宏观展望 【2020年】</a>
            <span>2020-09-10</span>
          </li>
          <li>
            <a href="https://forum.ccf.com.cn/fiber/meeting_detail.php?id=13" target="_blank"><font title="杭州·粘胶产业链论坛">▶▹</font> 中美博弈进行时 【2020年】】</a>
            <span>2020-11-03</span>
          </li>
          <li>
            <a href="https://forum.ccf.com.cn/fiber/meeting_detail.php?id=14" target="_blank"><font title="涤纶短纤高峰论坛">▶▹</font> 后疫情时代下的宏观环境及投资建议 【2020年】</a>
            <span>2020-07-31</span>
          </li>
          <li>
            <a href="https://forum.ccf.com.cn/fiber/meeting_detail.php?id=15" target="_blank"><font title="杭州·氨纶产业链论坛">▶▹</font> PTMEG的生产及应用 【2020年】</a>
            <span>2020-09-10</span>
          </li>
        </ul>
        <div class="experts-title">
          <h2>品牌介绍</h2>
        </div>
        <ul class="huizhan-ppjs clear">
            <li v-for="(item,index) in datas" :key="index">
              <a :href='item.url' target="_blank">
                <img :src='item.img' height="260" width="500"/>
              </a>
            </li>
        </ul>

      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header2";
import GoBack from "../layout/layout-goback";
export default {
  name: 'Exhibition',
  components:{
    LayoutHeader,
    GoBack
  },
  data () {
    return {
      datas:[
        {img:require('../../assets/img/6.jpg'),url:'https://www.ccf.com.cn/tb/2015/jz2015/'},
        {img:require('../../assets/img/10.jpg'),url:'https://www.ccf.com.cn/tb/2020/zy/index.php?id=1'},
        {img:require('../../assets/img/1.jpg'),url:'https://www.hengli.com/'},
        {img:require('../../assets/img/2.jpg'),url:'http://www.nbdafa.com/index.asp'},
        {img:require('../../assets/img/3.jpg'),url:'https://www.ccf.com.cn/tb/2020/chaoqun/'},
        {img:require('../../assets/img/4.jpg'),url:'https://www.ccf.com.cn/tb/2020/suhong/'},
        {img:require('../../assets/img/7.jpg'),url:'http://www.hlrefiber.com/'},
        {img:require('../../assets/img/5.jpg'),url:'http://www.ctamp.com.cn/'},
        {img:require('../../assets/img/8.jpg'),url:'https://www.ccf.com.cn/tb/2020/jinqi/'},
        {img:require('../../assets/img/9.jpg'),url:'https://www.ccf.com.cn/tb/2021/xinxiangbailu/xinx.html'}
      ]
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: calc(100% - 170px);
  padding-top: 170px;
  background: url("../../assets/erj_bj.fw.png");
  overflow: auto;
}

.layout-box::-webkit-scrollbar{
  display: none;
}

.secondary-content{
  width: 1100px;
  margin: 0 auto;
  position: relative;
  background: #0A47B6;
}

.experts-title{
  width:100%;
  height: 59px;
  background-image: linear-gradient(rgba(239,243,254,.2),rgba(197,210,250,.48));
}

.experts-title h2{
  font-family: "微软雅黑";
  line-height: 59px;
  color:#fff;
  font-style: oblique;
  padding-left: 20px;
}

.huizhan{
  padding: 30px 0 0 18px;
}

.huizhan li{
  width: 488px;
  height: 400px;
  padding: 10px;
  margin: 0 12px 25px 12px;
  background: #E3E9F6;
  cursor: pointer;
  box-shadow:0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  float: left;
  text-align: center;
}

.huizhan li:hover{
  background: #fff;
}

.huizhan li img{
  width: 100%;
}

.huizhan li p{
  width: 100%;
  font-size: 18px;
  line-height: 230%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #333;
  font-weight: bold;
}

.huizhan-p{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.huizhan-p font{
  color: #666;
  margin-left: 10px;
  line-height: 150%;
  font-size: 16px;
  font-weight: normal;
}

.huizhan-p span{
  background: #fff;
  border: 1px solid #6D9AF5;
  cursor: pointer;
  padding: 4px 20px;
  line-height: 150%;
  font-size: 16px;
  margin-right: 10px;
  font-weight: normal;
}

.huizhan-p span:hover{
  background: #0E4BCB;
  color: #fff;
}

.huizhan-hg{
  background: #E3E9F6;
  margin: 20px;
}

.huizhan-hg li{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100%-40px);
  padding: 15px 20px;
  margin: 5px 0;
}

.huizhan-hg li a{
  font-size: 18px;
  color: #092F7D;
  cursor: pointer;
  max-width: 940px;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.huizhan-hg li:hover{
  text-decoration: underline;
  background: #0B42AF;
}

.huizhan-hg li span{
  color: #092F7D;
  font-size: 14px;
}

.huizhan-hg li:hover a,.huizhan-hg li:hover span{
  color: #fff;
}

.huizhan-ppjs{
  padding: 20px 0 10px 10px;
}

.huizhan-ppjs li{
  float: left;
  margin: 0 10px 20px 10px;
  padding: 10px;
  background: #FFFFFF;
}

</style>




// WEBPACK FOOTER //
// src/views/secondary/secondary-exhibition-list.vue